import * as React from 'react';

import { OneTwoTripCarousel } from '../../components/OneTwoTripCarousel';
import { useOneTwoTripCarousel } from './useOneTwoTripCarousel';

export const OneTwoTripCarouselContainer: React.VFC = () => {
  const { slides, onSlideClick, onSlideShow } = useOneTwoTripCarousel();

  if (!slides.length) {
    return null;
  }

  return <OneTwoTripCarousel slides={slides} onSlideClick={onSlideClick} onSlideShow={onSlideShow} />;
};
